'use client'

import { hermesLogger } from '@core/observability'
import { ErrorInfo, PropsWithChildren, ReactElement } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { ErrorFallback } from './ErrorFeedback'

const logError = (error: Error, info: ErrorInfo) => {
  hermesLogger.error('[HUBR Frontend] Render error occurred', {
    page: window.location.href,
    info,
    error,
  })
}

const ErrorWrapper = ({
  children,
  fallbackComponent = ErrorFallback,
}: PropsWithChildren & {
  fallbackComponent?: () => JSX.Element | ReactElement
}) => {
  return (
    <ErrorBoundary
      FallbackComponent={fallbackComponent}
      onError={(error: Error, info: ErrorInfo) => logError(error, info)}
    >
      {children}
    </ErrorBoundary>
  )
}

export default ErrorWrapper
